import { render, staticRenderFns } from "./AccountComponentMovement.vue?vue&type=template&id=0fb19f0f"
import script from "./AccountComponentMovement.vue?vue&type=script&lang=js"
export * from "./AccountComponentMovement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports